import React, { useEffect, useMemo, useState } from "react";
import "./tenantonboard.css";
import CustomInputs from "../../common/Inputs";
import { FORM_CONTROLFIELD_TYPES } from "../../../constants/constants";
import { useError } from "../../../utils/context/ErrorContext";
import DateHelper from "../../../utils/DateHelper";
import UtilHelper from "../../../utils/UtilHelper";
import AddTraspButton from "../../firstTimeUserExperience/commonCom/AddTraspButton";
import { GetImages } from "../../../utils/GetImages";
import ActionMenu from "../../../newComponents/actionMenus/action-menu";
import dropdownIcon from "../../../assets/componentsIcons/dropdown/dropdown.svg";
import { TextCss } from "../../GlobalCss/TextCss";
import SeparaterLine from "../../common/SeparaterLine";
import { useOnboardingContext } from "../../../utils/context/OnboardingContext";
import { checkEmptyFieldsFunc, validateEmail } from "../../../utils/validateHelper";

const EmploymentHistory: React.FC<any> = ({ formData, setFormData }) => {
  const { errors, setErrors, errorMessages, setErrorMessages, clearErrors } = useError();
  const emptyEmploymentObject = {
    name: "",
    startDate: "",
    endDate: "",
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",

  };
 

  const [currentEntry, setCurrentEntry] = useState(emptyEmploymentObject);
  const [employmentList, setEmploymentList] = useState([]);
  const [editIndex, setEditIndex] = useState<number | null>(null);
const { isSignatureConfirm, countryCode } = useOnboardingContext();

// useEffect(() => {
//   setFormData((prev) => ({
//     ...prev,
//     EmploymentHistory: employmentList,
//   }));
// }, [employmentList]);
  // useEffect(() => {
  //   clearErrors();
  // }, []);

  const handleInputChange = (key: string, value: string) => {
    let sanitizedValue = value;
    if (key === "firstName" || key === "lastName") {
      sanitizedValue = value.replace(/[^a-zA-Z ]/g, "");
    }
    setCurrentEntry((prev) => ({ ...prev, [key]: sanitizedValue }));

    const errorKey = key;
    setErrors((prevErrors) => ({ ...prevErrors, [errorKey]: false }));
    setErrorMessages((prevMessages) => ({ ...prevMessages, [errorKey]: "" }));
  };

  const generateBasicDetails = () => [
    {
      name: "name",
      labelText: "Employer Name",
      type: FORM_CONTROLFIELD_TYPES.TEXT,
      value: currentEntry?.name,
      placeholder: "Enter Employer Name",
        isError: errors.name,
      errorMessages: errorMessages?.name,
    },
    {
      name: "startDate",
      labelText: "Start Date",
      type: FORM_CONTROLFIELD_TYPES.DATE,
      value: DateHelper.convertUTCtoDateTime2(currentEntry.startDate),
      placeholder: "Start Date",
       isError: errors.startDate,
      errorMessages: errorMessages?.startDate,
    },
    {
      name: "endDate",
      labelText: "End Date",
      type: FORM_CONTROLFIELD_TYPES.DATE,
      value: DateHelper.convertUTCtoDateTime2(currentEntry.endDate),
      placeholder: "End Date",
       isError: errors?.endDate,
    errorMessages: errorMessages?.endDate,
    },
    {
      name: "firstName",
      labelText: "First Name",
      type: FORM_CONTROLFIELD_TYPES.TEXT,
      value: currentEntry.firstName,
      placeholder: "Enter First Name",
       isError: errors?.firstName,
    errorMessages: errorMessages?.firstName,
    maxLength: 20,
    },
    {
      name: "lastName",
      labelText: "Last Name",
      type: FORM_CONTROLFIELD_TYPES.TEXT,
      value: currentEntry.lastName,
      placeholder: "Enter Last Name",
       isError: errors.lastName,
      errorMessages: errorMessages?.lastName,
      maxLength: 20,
    },
    {
      name: "email",
      labelText: "Email",
      type: FORM_CONTROLFIELD_TYPES.EMAIL,
      value: currentEntry.email,
      placeholder: "Enter Email",
       isError: errors?.email,
    errorMessages: errorMessages?.email,
    maxLength: 50,
    },
    {
      name: "phoneNumber",
      labelText: "Phone",
      type: FORM_CONTROLFIELD_TYPES.MOBILE,
      value: currentEntry.phoneNumber,
      placeholder: "Enter Phone No",
      maxLength: 10,
       isError: errors?.phoneNumber,
    errorMessages: errorMessages?.phoneNumber,
    },
  ];
 
 
  const isFormValid = useMemo(() => {
  return Object.values(currentEntry).every(
    (value) => value !== "" && value !== null
  );
}, [currentEntry]);

  const handleAddOrUpdate = () => {
     const hasError = checkEmptyFieldsFunc(
    currentEntry,
    clearErrors,
    errors,
    errorMessages,
    setErrors,
    setErrorMessages,
    [],
    countryCode
  );

  if (hasError) {
    return; 
  }
  const isEmailValid = validateEmail(
    currentEntry.email,
    setErrors,
    setErrorMessages
  );

  if (!isEmailValid) return;
    if (editIndex !== null) {
      // Update existing
      const updatedList = [...formData];
      updatedList[editIndex] = currentEntry;
      setEmploymentList(updatedList);
      setFormData((prev) => ({
        ...prev,
        EmploymentHistory: updatedList,
      }));
      setEditIndex(null);
    } else {
      
      const newList = [...employmentList, currentEntry];
      setEmploymentList(newList);
      setFormData((prev) => ({...prev,
        EmploymentHistory: [...(prev.EmploymentHistory || []), currentEntry],
      }));
      }
    setCurrentEntry(emptyEmploymentObject);
  };
  
  const handleEdit = (index: number) => {
    setCurrentEntry(formData[index]);
    setEditIndex(index);
  };

  const handleDelete = (index: number) => {
    const newList = formData?.filter((_, i) => i !== index);
    setEmploymentList(newList);
    setFormData((prev) => ({
      ...prev,
      EmploymentHistory: newList,
    }));
    if (editIndex === index) {
      // If deleting the item being edited
      setEditIndex(null);
      setCurrentEntry(emptyEmploymentObject);
    }
  };



  return (
    <>
      {/* Form */}<div className="pb-3">
      <div className="employment-row ">
        {generateBasicDetails().slice(0, 3).map((item, i) => (
          <div key={i} className="reference-input">
            <CustomInputs
              name={item.name}
              type={item.type}
              value={item.value}
              labelText={item.labelText}
              isFormControl={true}
              required={true}
              isError={item?.isError}
              errorMessages={item?.errorMessages}
              onChange={(e) => handleInputChange(item.name, e.target.value)}
              placeholder={item.placeholder}
              maxLength={item.maxLength}
              maxWidth={"100%"}
            />
          </div>
        ))}
       
      </div>
      <div className="employment-row">
        {generateBasicDetails().slice(3).map((item, i) => (
          <div key={i} className="reference-input">
            <CustomInputs
              name={item.name}
              type={item.type}
              value={item.value}
              labelText={item.labelText}
              required={'required'}
              isFormControl={true}
              isError={item?.isError}
              errorMessages={item?.errorMessages}
              onChange={(e) => handleInputChange(item.name, e.target.value)}
              placeholder={item.placeholder}
              maxLength={item.maxLength}
              maxWidth={"100%"}
            />
          </div>
        ))}
        
      </div>

      {/* <AddTraspButton
        type="button"
        bname={editIndex !== null ? "Save Changes" : "Add More"}
        onClick={handleAddOrUpdate}
        border={true}
        width="fit-content"
      /> */}
      <AddTraspButton
  type="button"
  bname={
    editIndex !== null || isFormValid
      ? "Save Changes"
      : "Add More"
  }
  onClick={handleAddOrUpdate}
  border={true}
  width="fit-content"
  // disabled={!isFormValid}
/>
      </div>
   <div className="separator-horizontal" />
      {/* List */}
      {formData?.length > 0 && (
        <div className="employment-history-list py-2">
          <p className={TextCss.black.heading_700_16}>Added History</p>
          {formData?.map((listingData, i) => (
            <div key={i} className={`listing-card mt-2`}>
              <div className="listing-card-header">
                <div className="listing-image-container">
                  <img
                    // src={listingPlaceholder}
                    src={GetImages.Company}
                    alt="Listing"
                    width={25}
                    height={25}
                    className="color-white-icon"
                  />
                </div>
                <div className="listing-details">
                  <div className="listing-info-container">
                    <div className="listing-info">
                      <h3 className="listing-address">
                        {listingData?.name}
                      </h3>
                      <p className="listing-type">
                        {listingData?.streetAddress}
                      </p>
                      <p className="listing-type">
                        {listingData?.firstName} {listingData?.lastName}•{listingData?.email} • {UtilHelper.formatPhoneForDisplay(listingData?.phoneNumber)}
                      </p>
                    </div>

                    <div className="financial-metrics">
                      <div className="metric">
                        <p className={TextCss.black.normal_text_700_14}>
                          {DateHelper.convertUTCtoDateTimeSimple(listingData?.startDate)}
                        </p>
                        <p className={TextCss.normal_text_400_14}>Start Date</p>
                      </div>
                      <SeparaterLine height={'40px'} background={''} />
                    
                      <div className="metric">
                        <p className={TextCss.black.normal_text_700_14}>
                          {DateHelper.convertUTCtoDateTimeSimple(listingData?.endDate)}
                        </p>
                        <p className={TextCss.normal_text_400_14}>Start Date</p>
                      </div>
                      <SeparaterLine height={'40px'} background={undefined} />
                    <div className="ps-3">

                      <ActionMenu
                        menuItems={[
                          {
                            icon: GetImages.BlackPencil,
                            label: "Edit",
                            action: () => handleEdit(i), // pass i + current data
                          },
                          { isDivider: true },
                          {
                            icon: GetImages.BlackDelete,
                            label: "Delete",
                            action: () => handleDelete(i), // just pass index
                            isDestructive: true,
                          },
                        ]}
                        Id={i}   // index passed correctly
                        trigger={
                          <button className="action-button">
                            <img
                              src={dropdownIcon}
                              alt="More options"
                              width={20}
                              height={20}
                              className="action-icon"
                            />
                          </button>
                        }
                      />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
         
        </div>
      )}
    </>
  );
};

export default EmploymentHistory;
